import { FaCarSide, FaTools, FaHandshake, FaDollarSign, FaRoad, FaStar } from 'react-icons/fa';

const whyChooseUs = {  
    sub: "Why Choose Us",
    heading: "Your Trusted Automotive Partner",
    points: [
        {
            id: 1,
            icon: <FaCarSide />,
            title: 'Wide Vehicle Selection',
            content: 'Explore a vast collection of vehicles from top manufacturers.',
        },
        {
            id: 2,
            icon: <FaTools />,
            title: 'Expert Service Team',
            content: 'Our certified technicians ensure your vehicle remains in top condition.',
        },
        {
            id: 3,
            icon: <FaHandshake />,
            title: 'Customer-Centric Approach',
            content: 'Experience personalized services and transparent pricing.',
        },
        {
            id: 4,
            icon: <FaDollarSign />,
            title: 'Competitive Pricing',
            content: 'We proudly offer the best deals on both new and used cars.',
        },
        {
            id: 5,
            icon: <FaRoad />,
            title: 'Test Drive Options',
            content: 'Take your dream car for a spin before making a decision.',
        },
        {
            id: 6,
            icon: <FaStar />,
            title: 'Exceptional Reviews',
            content: 'Join thousands of satisfied customers who trust us for their automotive needs.',
        },
    ]
}

export default whyChooseUs;